/** Номер банковской карты: только цифры, проверка Luhn и формат «0000 0000 0000 0000». */

export function cardDigits(value: string): string {
  return (value || '').replace(/\D/g, '').slice(0, 19);
}

export function formatCard(value: string): string {
  return cardDigits(value).replace(/(\d{4})(?=\d)/g, '$1 ');
}

export function luhnOk(digits: string): boolean {
  if (!/^\d{13,19}$/.test(digits)) return false;
  let sum = 0;
  for (let i = 0; i < digits.length; i++) {
    let n = Number(digits[digits.length - 1 - i]);
    if (i % 2 === 1) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
  }
  return sum % 10 === 0;
}

/** Платёжная система по первым цифрам (диапазоны IIN). null — пока не понять. */
export function cardScheme(digits: string): string | null {
  const d = cardDigits(digits);
  const n2 = Number(d.slice(0, 2));
  const n4 = Number(d.slice(0, 4));
  if (d.length >= 4 && n4 >= 2200 && n4 <= 2204) return 'Мир';
  if (d.length >= 4 && n4 >= 2221 && n4 <= 2720) return 'Mastercard';
  if (d.startsWith('4')) return 'Visa';
  if (d.length >= 2 && n2 >= 51 && n2 <= 55) return 'Mastercard';
  if (d.startsWith('62')) return 'UnionPay';
  if (d.startsWith('34') || d.startsWith('37')) return 'American Express';
  if (d.length >= 4 && n4 >= 3528 && n4 <= 3589) return 'JCB';
  if (d.startsWith('50') || (n2 >= 56 && n2 <= 58) || d.startsWith('63') || d.startsWith('67')) return 'Maestro';
  return null;
}

interface BinTable {
  banks: string[];
  bins: Record<string, number>;
}

let binTable: Promise<BinTable | null> | null = null;

/** Справочник BIN российских банков (public/card-bins-ru.json, ~20 КБ сжатым).
 *  Грузится один раз и только когда человек начал вводить карту. Наружу уходят
 *  ноль цифр карты: файл статический, поиск идёт в браузере. */
function loadBins(): Promise<BinTable | null> {
  if (!binTable) {
    binTable = fetch('/card-bins-ru.json')
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => {
        binTable = null; // сеть моргнула — в следующий раз попробуем снова
        return null;
      });
  }
  return binTable;
}

/** Банк-эмитент по первым шести цифрам. null — неизвестен или справочник не загрузился. */
export async function cardBank(digits: string): Promise<string | null> {
  const bin = cardDigits(digits).slice(0, 6);
  if (bin.length < 6) return null;
  const table = await loadBins();
  if (!table) return null;
  const index = table.bins[bin];
  return index === undefined ? null : table.banks[index] ?? null;
}
